/**
 * Soundcloud URL check
 * @param url
 * @returns boolean
 */
export const isSoundcloudURL = (url: string = ''): boolean => {
  const regex = /^(?:(https?):\/\/)?(?:(?:www|m)\.)?(soundcloud\.com|snd\.sc)\/(.*)$/
  return Boolean(url?.match(regex))
}
